
// Outcome of the last setWebhook attempt, written by core-cron's TgWebhookService.
// Null means it has never tried — the bot was only just created, or
// autoRegisterWebhook is off and registration is being done by hand.
export const TG_WEBHOOK_STATUS = ['ok', 'failed'];
